export default __webpack_public_path__ + "static/media/avatar.c7ec20ef.png";